import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTCheckbox {
    innerValue = true;

    $onChanges() {
        this.innerValue = this.value;
    }

    valueChange() {
        const value = this.innerValue;

        this.onChange({ value });
    }
}

export const TFTCheckboxConfiguration = {
    template,
    bindings: {
        checkboxId: '<',
        required: '<',
        value: '<',
        fieldName: '<',
        labelTranslateKey: '@',
        onChange: '&',
    },
    controller: TFTCheckbox,
    controllerAs: 'checkboxCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftCheckbox', TFTCheckboxConfiguration);
